import {css} from "styled-components";

type FlexDirection = "row" | "column" | "row-reverse" | "column-reverse";
type JustifyContent =
    | "center"
    | "flex-start"
    | "flex-end"
    | "space-between"
    | "space-around";
type AlignItems = "center" | "flex-start" | "flex-end" | "stretch" | "baseline";

interface TextMixinProps {
    fontFamily?: string;
    lineHeight?: number | string;
    fontSize?: string;
    fontWeight?: number;
    color?: string;
}

export const flexMixin = (
    flexDirection: FlexDirection = "row",
    justifyContent: JustifyContent = "center",
    alignItems: AlignItems = "center"
) => css`
    display: flex;
    display: -webkit-flex;
    flex-direction: ${flexDirection};
    -webkit-flex-direction: ${flexDirection};
    justify-content: ${justifyContent};
    -webkit-justify-content: ${justifyContent};
    align-items: ${alignItems};
    -webkit-align-items: ${alignItems};
`;

export const textMixin = ({
    fontFamily = "Inter, sans-serif",
    lineHeight = 1.5,
    fontSize = "0.875rem",
    fontWeight = 400,
    color = "#333333",
}: TextMixinProps = {}) => css`
    font-family: ${fontFamily};
    line-height: ${lineHeight};
    font-size: ${fontSize};
    font-weight: ${fontWeight};
    color: ${color};
    font-style: normal;
`;

export const respondTo = {
    mobile: (...args: Parameters<typeof css>) => css`
        @media (max-width: 480px) {
            ${css(...args)}
        }
    `,
    tablet: (...args: Parameters<typeof css>) => css`
        @media (max-width: 768px) {
            ${css(...args)}
        }
    `,
    desktop: (...args: Parameters<typeof css>) => css`
        @media (max-width: 1024px) {
            ${css(...args)}
        }
    `,
    wide: (...args: Parameters<typeof css>) => css`
        @media (max-width: 1200px) {
            ${css(...args)}
        }
    `,
};
